import styled, { css } from "styled-components";

interface BackdropProps {
  open: boolean;
}

interface ContainerProps {
  modalWidth: string | number;
}

export const Backdrop = styled.div<BackdropProps>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(22, 28, 36, 0.6);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  transition: visibility 200ms, opacity 200ms;

  ${({ open }) =>
    open &&
    css`
      visibility: visible;
      opacity: 1;
    `};
`;

export const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ modalWidth }) => (typeof modalWidth === "number" ? `${modalWidth}px` : modalWidth)};
  max-height: 90vh;
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;

  @media (max-width: 768px) {
    width: 95vw;
    max-height: 95vh;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px 16px 32px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: var(--black);
  margin: 0;
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: var(--sub-title);
  margin: 0;
  line-height: 1.5;
`;

export const CloseBtn = styled.button`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  color: var(--sub-title);
  transition: all 0.2s ease-in-out;
  margin-top: -4px;
  margin-right: -8px;

  &:hover {
    background: var(--background);
    color: var(--black);
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 32px;
  overflow-y: auto;
  flex: 1;

  /* Custom Scrollbar for the body */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d1d1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  background: var(--background);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0 0 16px 16px;
`;

export const LeftFooter = styled.div`
  display: flex;
  align-items: center;
  
  .checkbox-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    color: var(--title);
  }
`;

export const RightFooter = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;